import { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import TrustBar from './components/TrustBar';
import Services from './components/Services';
import Stats from './components/Stats';
import WhoWeServe from './components/WhoWeServe';
import HowItWorks from './components/HowItWorks';
import Testimonials from './components/Testimonials';
import Faq from './components/Faq';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';

const Home = () => {
  useEffect(() => {
    document.title = 'Trusted Home Leads. Booked Appointments for Local Contractors';
  }, []);
  return (
    <div className="bg-[#faf9f5] text-[#0b0f0d] min-h-screen overflow-x-hidden">
      <Navbar />
      <Hero />
      <TrustBar />
      <Services />
      <Stats />
      <WhoWeServe />
      <HowItWorks />
      <Testimonials />
      <Faq />
      <FinalCTA />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
